import React from 'react';
import { ArrowLeft, Play, Navigation } from 'lucide-react';

function DeliveryListHeader({ setActiveComponent, onStartRoute, canStartRoute, loadingRoutes, routeStarted }) {
  return (
    <div className="bg-white shadow-sm border-b border-gray-200">
      <div className="flex items-center justify-between px-4 py-3">
        {/* Back Button */}
        <button
          onClick={() => setActiveComponent('OptionsDriver')}
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          aria-label="Volver"
        >
          <ArrowLeft className="w-6 h-6 text-gray-700" />
        </button>

        {/* Start Route Button */}
        <button
          onClick={onStartRoute}
          disabled={!canStartRoute || loadingRoutes}
          className={`
            flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all
            ${canStartRoute && !loadingRoutes
              ? 'bg-brand-primary text-white hover:bg-brand-primary/90 shadow-md'
              : routeStarted
              ? 'bg-brand-green text-white cursor-not-allowed'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }
          `}
          aria-label={routeStarted ? 'Ruta iniciada' : 'Iniciar ruta'}
        >
          {loadingRoutes ? (
            <>
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
              <span className="text-sm">Procesando...</span>
            </>
          ) : routeStarted ? (
            <>
              <Navigation className="w-5 h-5" />
              <span className="text-sm">En Ruta</span>
            </>
          ) : (
            <>
              <Play className="w-5 h-5" />
              <span className="text-sm">Iniciar Ruta</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
}

export default DeliveryListHeader;